export interface DurationOption {
    value: number;
    label: string;
}

export function buildDurationOptions(incrementMinutes: number): DurationOption[] {
    const options: DurationOption[] = [];
    for (let m = incrementMinutes; m <= 240; m += incrementMinutes) {
        const h = Math.floor(m / 60);
        const mm = String(m % 60).padStart(2, "0");
        options.push({ value: m, label: `${h}:${mm}` });
    }
    return options;
}

export function formatDuration(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const mm = String(minutes % 60).padStart(2, "0");
    return `${h}:${mm}`;
}

export function formatDurationFriendly(minutes: number): string {
    if (minutes <= 0) return "0m";
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0) return `${m}m`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}m`;
}
